// The time zones of Funtour's usual destinations, for the hotel form (owner report, 2026-10-29: an operator could not type
// «America/Camboriu» — it does not exist — and entered «America/Santiago» for a hotel in Brazil, which shows the stay at
// the wrong hour). The hotel's zone is the zone of the DESTINATION, not of the school or the tenant. Every value is a
// canonical IANA name; the API accepts any other valid IANA zone too (see the «Otra» option of the form).

export interface HotelTimeZone {
  /** The IANA identifier stored in the database. */
  readonly value: string;
  /** What the operator reads in the list: country, the places it covers and the technical name. */
  readonly label: string;
  /** ISO 3166-1 alpha-2 codes whose hotels normally use it (used to suggest it when the country is typed). */
  readonly countries: readonly string[];
}

export const HOTEL_TIME_ZONES: readonly HotelTimeZone[] = [
  { value: 'America/Santiago', label: 'Chile · America/Santiago', countries: ['CL'] },
  {
    value: 'America/Sao_Paulo',
    label: 'Brasil (Camboriú, Florianópolis, Río, São Paulo…) · America/Sao_Paulo',
    countries: ['BR'],
  },
  {
    value: 'America/Argentina/Buenos_Aires',
    label: 'Argentina (Bariloche, Buenos Aires, Mendoza…) · America/Argentina/Buenos_Aires',
    countries: ['AR'],
  },
  { value: 'America/Asuncion', label: 'Paraguay · America/Asuncion', countries: ['PY'] },
  { value: 'America/Montevideo', label: 'Uruguay · America/Montevideo', countries: ['UY'] },
];

/** The usual zone of a country (two-letter code, any case), or undefined when it is not one of the usual destinations. */
export function timeZoneForCountry(countryCode: string): string | undefined {
  const code = countryCode.trim().toUpperCase();
  return HOTEL_TIME_ZONES.find((zone) => zone.countries.includes(code))?.value;
}

/** True when the value is one of the listed zones (so the form shows it in the list instead of the free-text field). */
export function isListedTimeZone(value: string): boolean {
  return HOTEL_TIME_ZONES.some((zone) => zone.value === value);
}
